
    import './styles.scoped.css';
    export default {
  "top-navigation": "awsui_top-navigation_k5dlb_oc0g1_9",
  "padding-box": "awsui_padding-box_k5dlb_oc0g1_42",
  "medium": "awsui_medium_k5dlb_oc0g1_52",
  "narrow": "awsui_narrow_k5dlb_oc0g1_52",
  "virtual": "awsui_virtual_k5dlb_oc0g1_63",
  "hidden": "awsui_hidden_k5dlb_oc0g1_67",
  "\t": "awsui_\t_k5dlb_oc0g1_1",
  "identity": "awsui_identity_k5dlb_oc0g1_79",
  "identity-link": "awsui_identity-link_k5dlb_oc0g1_82",
  "no-logo": "awsui_no-logo_k5dlb_oc0g1_102",
  "logo": "awsui_logo_k5dlb_oc0g1_106",
  "title": "awsui_title_k5dlb_oc0g1_118",
  "inputs": "awsui_inputs_k5dlb_oc0g1_134",
  "search": "awsui_search_k5dlb_oc0g1_142",
  "search-expanded": "awsui_search-expanded_k5dlb_oc0g1_146",
  "utilities": "awsui_utilities_k5dlb_oc0g1_150",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_oc0g1_161",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_oc0g1_182",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_oc0g1_187",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_oc0g1_196",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_oc0g1_204",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_oc0g1_208",
  "offset-right-none": "awsui_offset-right-none_k5dlb_oc0g1_212",
  "offset-right-l": "awsui_offset-right-l_k5dlb_oc0g1_216",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_oc0g1_220",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_oc0g1_225",
  "overflow-menu": "awsui_overflow-menu_k5dlb_oc0g1_225",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_oc0g1_266",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_oc0g1_274",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_oc0g1_281",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_oc0g1_290",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_oc0g1_298",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_oc0g1_302",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_oc0g1_306",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_oc0g1_344",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_oc0g1_352",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_oc0g1_355",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_oc0g1_344",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_oc0g1_391",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_oc0g1_344",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_oc0g1_400",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_oc0g1_403",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_oc0g1_412",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_oc0g1_418",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_oc0g1_422",
  "icon": "awsui_icon_k5dlb_oc0g1_427",
  "icon-open": "awsui_icon-open_k5dlb_oc0g1_441"
};
  